import { Component, OnInit } from "@angular/core";
import { VersionService } from "../service/version/version.service";

@Component({
  selector: "app-footer-cmp",
  templateUrl: "footer.component.html",
})
export class FooterComponent implements OnInit {
  test: Date = new Date();
  versionNumber: string = "";

  constructor(private readonly version: VersionService) {}

  ngOnInit(): void {
    this.version.getVersion().subscribe((ver) => {
      this.versionNumber = ver;
    });
  }
}
